import { render, staticRenderFns } from "./PartnerProductAccountList.vue?vue&type=template&id=7c25effd&scoped=true&"
import script from "./PartnerProductAccountList.vue?vue&type=script&lang=js&"
export * from "./PartnerProductAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c25effd",
  null
  
)

export default component.exports